import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { UserDevice } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "UserDevice";
export const UserDeviceService = {
	endpoint,
	checkRegistration: async (deviceId: string) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/CheckRegistration`, {body: JSON.stringify({deviceId}), headers: {"Content-Type": "application/json"}, method: "POST"}),
	createSingle: async (data: UserDevice) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	removeRegistration: async (deviceId: string) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/RemoveRegistration`, {body: JSON.stringify({deviceId}), headers: {"Content-Type": "application/json"}, method: "POST"}),
	updateSingleById: async (id: number, data: UserDevice) => await Service.updateSingleById(endpoint, id, data)
}